import { convertNumberToWords, currency } from "../../utils/number.utils";
import { textToNumber } from "../../utils/string.utils";

export default function InwordsTotalField({ watch, control, errors, setValue, others }) {
  const price = textToNumber(watch("car.price"));
  const registrationCost = textToNumber(watch("car.registration_cost"));
  const discount = textToNumber(watch("car.discount"));

  // additional cost
  const additionalCost = watch(`car.additionalCost`)?.length
    ? watch(`car.additionalCost`)?.reduce((prev, _, index) => {
        const price = watch(`car.additionalCost.${index}.cost`);
        return price ? prev + Number(price) : prev;
      }, 0)
    : 0;

  const singleTotal = additionalCost + price + registrationCost - discount;
  const total = currency(singleTotal);
  const inwords = convertNumberToWords(singleTotal);

  return (
    <div className="card mb-3">
      <div className="card-body">
        <p className="mb-0">
          <span style={{ fontWeight: 600 }}>Total:</span> {total}
        </p>
        <p className="mb-0">
          <span style={{ fontWeight: 600 }}>Inwords:</span> {inwords}
        </p>
      </div>
    </div>
  );
}
